import NavbarIcon from "./NavbarIcon";
import { useNavigate } from "react-router-dom";
import { logout } from "../../api/auth";
import { useSetRecoilState } from "recoil";
import { inOutMonthFilterState } from "../../utils/atoms/atoms";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthProvider";
import { HasRole } from "../../context/HasRole";

const Navbar = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setMonthFilterType = useSetRecoilState(inOutMonthFilterState);

  const { user } = useAuth();

  return (
    <nav className="navbar">
      <div className="nav-brand" aria-label="Pressco home">
        <span className="nav-brand-mark">P</span>
        <span className="nav-brand-name">Pressco</span>
      </div>
      <div className="nav-links" aria-label="Primary navigation">
        <NavbarIcon id="todos" label="✓ TODOs" />
        <HasRole roles={["admin", "superadmin"]}>
          <NavbarIcon id={"register"} />
        </HasRole>
        <HasRole roles={["admin", "accounts"]}>
          <NavbarIcon id={"attendance"} />
          <NavbarIcon id={"salary"} />
          <NavbarIcon id={"costing"} />
        </HasRole>
        <NavbarIcon id={"inventory"} />
        <NavbarIcon id="tool-development" label="Tool Development" />
        <NavbarIcon
          id={"in-Out"}
          onClickFn={() => setMonthFilterType("current")}
        />
        <NavbarIcon id={"incoming-Items"} />
        <NavbarIcon id="inventory-reports" label="Inventory Reports" />
      </div>

      <div className="nav-user">
        <div className="nav-username mobile-d-none">
          <span>Signed in as</span>
          <strong className="text-capitalize">{user?.username}</strong>
        </div>
        <button
          type="button"
          className="nav-logout"
          aria-label="Log out"
          onClick={async () => {
            await logout();
            queryClient.removeQueries();
            navigate("/login");
          }}
        >
          <i className="bi bi-box-arrow-right" aria-hidden="true"></i>
          <span className="mobile-d-none">Logout</span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
